import i18n from '@/plugins/i18n';

class ErrorManager {
    public processErrorCustomMessage(error: any, customErrorMessage: string) {
        return this.commonProcessError(error, customErrorMessage);
    }

    public processError(error: any) {
        return this.commonProcessError(error);
    }

    private getMessageFromCodeError(codeError: number): string {
        if (codeError === 401) {
            return 'app.error.unauthorized';
        } else if (codeError === 403) {
            return 'app.error.missing.right';
        } else if (codeError === 500) {
            return 'app.error.server';
        } else {
            return 'app.error.undefined';
        }
    }

    private commonProcessError(error: any, customErrorMessage?: string) {
        const errorMessage = i18n.global.t('app.error.undefined');

        if (customErrorMessage) {
            return i18n.global.t(customErrorMessage);
        }

        if (error === 'token_invalidated') {
            return 'silent_fail';
        }

        if (error?.response?.data?.message) {
            return i18n.global.t(error.response.data.message);
        }

        if (error?.data?.message) {
            return error.data.message;
        }

        const statusCode = error?.response?.status || error?.status;
        if (statusCode) {
            return i18n.global.t(this.getMessageFromCodeError(statusCode));
        }

        return errorMessage;
    }
}

export default new ErrorManager();
